import React from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from './Modal';
import Button from './Button';

interface LoginPromptProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
  redirectTo?: string;
}

const LoginPrompt: React.FC<LoginPromptProps> = ({ 
  isOpen, 
  onClose, 
  message = 'Please log in to access this feature.',
  redirectTo
}) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate('/login', { state: { redirectTo } });
  };

  const handleSignup = () => {
    onClose();
    navigate('/signup', { state: { redirectTo } });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Login Required">
      <div className="p-6">
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex gap-3 justify-end">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={handleSignup}>
            Sign Up
          </Button>
          <Button variant="primary" onClick={handleLogin}>
            Log In
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LoginPrompt;

